import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import genCompletedIcon from '../../../assets/gen_completed.svg';
import { getDefaultDateStringValue, getDefaultTimeStringValue } from '../../../../models/UiUtils';
import { CampaignResource } from './campaignSessionStore';
import { s } from './styles';
import { IAIScheduleSuccessProps } from './types';

interface PrimaryResourceDisplayProps {
	resource: CampaignResource;
	props?: IAIScheduleSuccessProps;
	showScheduledText?: boolean;
}

export const PrimaryResourceDisplay: React.FC<PrimaryResourceDisplayProps> = ({
	resource,
	props,
	showScheduledText = true,
}) => {
	const iconStyles = [s.primaryResourceIcon, s.primaryResourceIconBackground];

	const getScheduledText = (): string | null => {
		const resourceType = resource.type;

		switch (resourceType) {
			case 'email':
				if (resource.scheduledDate) {
					return `Your emails will start to send on ${getDefaultDateStringValue(
						resource.scheduledDate
					)} at ${getDefaultTimeStringValue(resource.scheduledDate)}.`;
				}
				if (props?.resourceType === 'email') {
					const { estimate } = props;
					if (estimate) {
						return `Your emails will start to send on ${getDefaultDateStringValue(
							estimate.estimate.startDate
						)} at ${getDefaultTimeStringValue(estimate.estimate.startDate)}.`;
					}
				}
				return 'Your emails have been scheduled successfully.';

			case 'social': {
				if (resource.scheduledDate) {
					const isSendNow = moment(resource.scheduledDate).diff(moment(), 'minutes') <= 5;
					return isSendNow
						? 'Your post will be delivered in the next 5 minutes.'
						: `Your post will be delivered on ${getDefaultDateStringValue(resource.scheduledDate)} at ${getDefaultTimeStringValue(resource.scheduledDate)}.`;
				}
				if (props?.resourceType === 'social') {
					const { socialPost } = props;
					if (socialPost?.dueMoment) {
						const isSendNow = moment(socialPost.dueMoment).diff(moment(), 'minutes') <= 5;
						return isSendNow
							? 'Your post will be delivered in the next 5 minutes.'
							: `Your post will be delivered on ${getDefaultDateStringValue(socialPost.dueMoment)} at ${getDefaultTimeStringValue(socialPost.dueMoment)}.`;
					}
				}
				return 'Your post has been scheduled successfully.';
			}

			case 'blog': {
				if (resource.scheduledDate) {
					return `Your blog will be published on ${getDefaultDateStringValue(resource.scheduledDate)} at ${getDefaultTimeStringValue(resource.scheduledDate)}.`;
				}
				if (props?.resourceType === 'blog') {
					const { blogPost } = props;
					if (blogPost?.scheduledSendDate) {
						return `Your blog will be published on ${getDefaultDateStringValue(blogPost.scheduledSendDate)} at ${getDefaultTimeStringValue(blogPost.scheduledSendDate)}.`;
					}
				}
				return 'Your blog has been scheduled successfully.';
			}

			default:
				return null;
		}
	};

	const scheduledText = showScheduledText ? getScheduledText() : null;

	return (
		<div className={css(s.primaryResourceContainer)}>
			<div className={css(...iconStyles)}>
				<img src={genCompletedIcon} alt='Completed' className={css(s.primaryResourceImage)} />
			</div>
			{scheduledText && <div className={css(s.primaryResourceText)}>{scheduledText}</div>}
		</div>
	);
};
